import React from 'react'
import PageLayout from '../PageLayout/PageLayout'

/**
 * @extends PageLayout
 * @see https://simonsmith.io/reusing-layouts-in-react-router-4/
 */
const SignupLayout = ({component: Component, ...rest}) => (
  <PageLayout {...rest} component={matchProps =>
    <Component {...matchProps}/>
  } />
)

export default SignupLayout



// WEBPACK FOOTER //
// ./src/layouts/SignupLayout/SignupLayout.js